import React from "react";

import type { SmallLinkTilesWrapper as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { SpacerBlock } from "../SpacerBlock";
import { SmallLinkTiles } from "./SmallLinkTiles";

const components = {
    small_link_tiles: SmallLinkTiles,
    spacer: SpacerBlock,
};

export const SmallLinkTilesWrapper = ({ value }: { value: Value }) => {
    if (!value.items) return <></>;
    return (
        <Themed theme={value.theme} tag="section">
            <StreamField
                tagName={React.Fragment}
                components={components}
                value={value.items}
            />
        </Themed>
    );
};
